/**
 * The temp workers a task can be linked to, until the api lists them for the
 * CRM: validated ones and others still waiting for their check.
 */
export const TASK_TEMP_WORKERS = [
  {
    id: 'tw1',
    firstname: 'Kévin',
    lastname: 'Rosemond',
    city: 'Le Lamentin',
    validated: true,
  },
  {
    id: 'tw2',
    firstname: 'Mélissa',
    lastname: 'Desroses',
    city: 'Schœlcher',
    validated: true,
  },
  {
    id: 'tw3',
    firstname: 'Steeve',
    lastname: 'Lordinot',
    city: 'Le Robert',
    validated: false,
  },
  {
    id: 'tw4',
    firstname: 'Laetitia',
    lastname: 'Bellemare',
    city: 'Ducos',
    validated: true,
  },
  {
    id: 'tw5',
    firstname: 'Dimitri',
    lastname: 'Sainte-Rose',
    city: 'Le François',
    validated: true,
  },
  {
    id: 'tw6',
    firstname: 'Cindy',
    lastname: 'Jean-Baptiste',
    city: 'Sainte-Marie',
    validated: false,
  },
  {
    id: 'tw7',
    firstname: 'Johan',
    lastname: 'Bellance',
    city: 'Fort-de-France',
    validated: true,
  },
  {
    id: 'tw8',
    firstname: 'Nadège',
    lastname: 'Pélage',
    city: 'Rivière-Salée',
    validated: true,
  },
  {
    id: 'tw9',
    firstname: 'Teddy',
    lastname: 'Marie-Sainte',
    city: 'Le Marin',
    validated: false,
  },
  {
    id: 'tw10',
    firstname: 'Sabrina',
    lastname: 'Joseph-Angélique',
    city: 'La Trinité',
    validated: true,
  },
  {
    id: 'tw11',
    firstname: 'Willy',
    lastname: 'Chéry',
    city: 'Saint-Joseph',
    validated: true,
  },
  {
    id: 'tw12',
    firstname: 'Stéphanie',
    lastname: 'Louis-Sidney',
    city: 'Basse-Pointe',
    validated: false,
  },
];
